export enum ECategoryImageType {
	black,
	white
}
